import { analyticsService, AnalyticsEventCatalog } from "../index";

/**
 * @param {{ authProvider?: string }} [params]
 */
export function trackProfileCreated(params = {}) {
  /** @type {import("../analytics.types").AnalyticsEventParams} */
  const payload = {};
  if (params.authProvider) {
    payload.auth_provider = params.authProvider;
  }
  analyticsService.track(AnalyticsEventCatalog.PROFILE_CREATED, payload);
}

/**
 * @param {{ completionPercent: number; hasAvatar?: boolean }} params
 */
export function trackProfileCompleted(params) {
  analyticsService.track(AnalyticsEventCatalog.PROFILE_COMPLETED, {
    completion_percent: Math.min(100, Math.max(0, Math.round(params.completionPercent))),
    ...(params.hasAvatar != null ? { has_avatar: Boolean(params.hasAvatar) } : {}),
  });
}

/**
 * @param {{ fieldsUpdatedCount: number; fieldGroup?: "identity" | "contact" | "preferences" }} params
 */
export function trackProfileUpdated(params) {
  const payload = {
    fields_updated_count: Math.max(0, params.fieldsUpdatedCount),
  };
  if (params.fieldGroup) {
    payload.field_group = params.fieldGroup;
  }
  analyticsService.track(AnalyticsEventCatalog.PROFILE_UPDATED, payload);
}

const IDENTITY_FIELDS = new Set([
  "displayName",
  "bio",
  "gender",
  "preferredHand",
  "city",
  "country",
  "countryIso",
]);
const CONTACT_FIELDS = new Set(["contactEmail", "phoneNationalNumber", "phoneCountryCode"]);

/**
 * @param {Record<string, unknown>} patch
 * @returns {"identity"|"contact"|"preferences"|undefined}
 */
export function inferProfileFieldGroup(patch) {
  const keys = Object.keys(patch || {});
  if (keys.some((k) => CONTACT_FIELDS.has(k))) return "contact";
  if (keys.some((k) => IDENTITY_FIELDS.has(k))) return "identity";
  if (keys.length) return "preferences";
  return undefined;
}
